<script>
import deleteDialog from "../../../../dialogs/DeleteDialog.vue";
import Vue from "vue";
import axios from "axios";
import addDialog from "./addDialog";

import {getLessonFullName} from "@/utils/parseObj";
import SelectLesson from "@/components/selects/SelectLesson";

export default {
    name: "ReportRatingsSubject",
    components: {SelectLesson, deleteDialog, addDialog},
    data() {
        return {
            ENTITY: 'report',
            data: null,
            loading: true,
            isDialogDelete: false,
            isDialogAdd: false,
            selectedRows: [],
            filters: {},
            itemBeforeEditing: {},
            itemAfterEditing: {},
            columns: [
                {field: "id", header: "ת.ז.", type: "string", editable: false},
                {field: "hebrewName", header: "שם", type: "string", editable: true},
                {field: "options", header: "הגדרות", type: "string", editable: true},
                {field: "starsCount", header: "כמות כוכבים", type: "number", editable: true},
                {field: "subjectName", header: "נושא", type: "string", editable: true},
                {field: "grades", header: "שיוך לכתות, לפ מזהה מופרד בפסיקים", type: "string", editable: true},
                {field: "subject", header: "שיוך למקצוע", type: "subject", editable: true},
                {field: "active", header: "פעיל", type: "checkbox", editable: true},
            ],
        }


    },
    created() {
        this.fetchData()
    },
    methods: {
        copyRatesCodes(){
            let text = ""
            this.selectedRows.forEach((row) => {
                for (let i = 1; i <= row.starsCount; i++) {
                    text += "r." + row.id + "." + i + "\t"
                }

                text += "\n"
            })
            navigator.clipboard.writeText(text).then(() => {
                this.openNotification("success", `מעולה`, "הנתונים הועתקו בהצלחה! ניתן להדביק בוורד.");
            }).catch(err => {
                this.openNotification("danger", `אופס`, `שגיאה בהעתקה ללוח:`);
            });
            console.log(text)
        },
        getLessonName(id) {
            return getLessonFullName(id)
        },
        addItem(item) {
            this.data.push(item);
        },
        deleteItem(choice) {
            this.loading = true

            this.isDialogDelete = false;
            if (choice) {
                const itemsIds = [];
                this.selectedRows.forEach((item) => {
                    itemsIds.push(item.id);
                });

                this.selectedRows.forEach((selected) => {
                    this.data = this.data.filter((item) => item.id !== selected.id);
                });

                axios.delete(`/${this.ENTITY}/delete-many`,
                    {
                        data: itemsIds
                    }
                ).then(() => {
                    this.loading = false
                    this.openNotification("success", `מעולה`, `מחקנו ${itemsIds.length}  רשומות מהמערכת`);
                    this.selectedRows = [];
                }).catch(() => {
                    this.loading = false
                    this.openNotification("danger", `אופס`, `לא הצלחנו למחוק את הרשומות מהמערכת`);
                    this.data.push(...this.selectedRows)
                    this.selectedRows = [];
                });

                this.isDialogDelete = false;
            }
        },
        async fetchData() {
            try {
                const {data} = await axios.get(`${this.ENTITY}/all-ratings`)
                console.log("responseresponse", data)
                this.data = data
            } catch (e) {
                console.log(e)
                this.openNotification("danger", `אופס`, `תקלה בטעינת נתוני תאריכי מערכת`);
            }
            this.loading = false
        },
        rowClass(data) {
            return data.active === false ? "row-unenabled" : null;
        },
        async onCellEditComplete(event) {
            try {
                let objToSend = {}
                if (this.itemAfterEditing?.id === undefined) {
                    objToSend = event.data

                } else {
                    const index = this.data.findIndex(
                        (item) => item.id === this.itemAfterEditing.id
                    );
                    this.data[index] = this.itemAfterEditing;
                    Vue.set(this.data, index, this.itemAfterEditing);
                    objToSend = JSON.parse(JSON.stringify(this.itemAfterEditing));
                    console.log(this.itemAfterEditing)
                }

                if (!objToSend.id) throw "error"
                await axios.put(`${this.ENTITY}/update-rating`, objToSend)
                this.openNotification(
                    "success",
                    `מעולה`,
                    `רשומה התעדכנה`
                )
            } catch (e) {
                console.log(e)
                this.openNotification(
                    "danger",
                    `אופס`,
                    `${e} : רשומה לא התעדכנה`
                );
            }
        },
        onCellEdit(newValue, props) {
            this.itemBeforeEditing = {...props.data};
            this.itemAfterEditing = {...props.data};
            this.itemAfterEditing[props.column.field] = newValue;
        },
        openNotification(
            color,
            title,
            text,
            position = "right-left",
            duration = 3000
        ) {
            this.$vs.notification({
                color,
                position,
                title,
                text,
                duration,
                progress: "auto",
            });
        },
    }
    ,
}
</script>

<template>
    <div>
        <DataTable
                :rowClass="rowClass"
                :value="data"
                :selection.sync="selectedRows"
                @cell-edit-complete="onCellEditComplete"
                columnResizeMode="fit"
                dataKey="id"
                :filters="filters"
                class="
          p-datatable-customers
          p-datatable-sm
          p-datatable-gridlines
          p-datatable-striped
        "
                stateStorage="local"
                stateKey="system-messages-data-state"
                editMode="cell"
                :loading="loading"
                sortField="createdAt"
                :sortOrder="-1"
                :resizableColumns="false"

                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 20, 50]"
                currentPageReportTemplate="מציג {first} עד {last} מתוך {totalRecords}"
        >
            <!-- header -->

            <template #header>
                <div class="p-p-2 table-header">
                    <div class="p-m-1 p-d-inline-flex">
                        <h1 style="text-align: center">הגדי תעודה</h1>
                    </div>

                    <div class="p-d-flex">
                        <Button

                                v-tooltip.top="'העתק קודים'"
                                v-if="selectedRows.length > 0"
                                icon="pi pi-clone"
                                class="p-mr-2 p-button-primary"
                                @click="copyRatesCodes"
                        />
                        <Button
                                v-tooltip.top="'מחיקה'"
                                v-if="selectedRows.length > 0"
                                icon="pi pi-trash"
                                class="p-mr-2 p-button-danger"
                                @click="isDialogDelete = true"
                        />
                        <Button
                                v-tooltip.top="'הוספה'"
                                icon="pi pi-plus"
                                class="p-mr-2 p-button-success"
                                @click="isDialogAdd = true"
                        />
                    </div>
                </div>
            </template>
            <template #loading> טוען נתונים מהמערכת, אנא המתן...</template>
            <Column selectionMode="multiple" headerStyle="width: 3em"></Column>

            <!-- v-for -->
            <Column
                    sortable

                    :sortField="col.field || col.sort"
                    headerStyle="text-align: rtl"
                    bodyStyle="text-align: right;  overflow-wrap: break-word"
                    v-for="col of columns"
                    :field="col.field"
                    :header="col.header"
            >
                <template #filter>
                    <InputText
                            type="text"
                            v-model="filters[col.field]"
                            class=""
                            :placeholder="`חפש לפי ${col.header}`"
                    />
                </template>
                <template #body="slotProps">
                    <div v-if="col.type === 'string'">
                        {{ slotProps.data[col.field] }}
                    </div>
                    <div v-if="col.type === 'number'">
                        {{ slotProps.data[col.field] }}
                    </div>
                    <div v-if="col.type === 'subject'">
                      {{ getLessonName(slotProps.data[col.field]) }}
                    </div>
                    <div v-if="col.type === 'grade'">
                        {{ getGradeName(slotProps.data[col.field]) }}
                    </div>
                    <div v-if="col.type === 'date'">
                        {{ new Date(slotProps.data[col.field]).toLocaleDateString() }}
                    </div>
                    <div v-if="col.type === 'user'">
                        {{ getTeacherName(slotProps.data[col.field]) }}
                    </div>
                    <div v-if="col.type === 'checkbox'">
                        <checkbox
                                @input="onCellEdit($event, slotProps)"

                                v-model="slotProps.data[col.field]"
                                :binary="true"/>
                    </div>
                </template>

                <template v-if="col.editable " #editor="slotProps">
                    <div v-if="col.type === 'string'">
                           <Textarea
                                :value="slotProps.data[slotProps.column.field]"
                                @input="onCellEdit($event, slotProps)"

                        />
                    </div>
                    <div v-if="col.type === 'number'">
                        <InputNumber
                                :value="slotProps.data[slotProps.column.field]"
                                @input="onCellEdit($event, slotProps)"

                        />
                    </div>
                    <div v-if="col.type === 'subject'">
                        <select-lesson  v-on:onSelect="onCellEdit($event.id, slotProps)" :defaultValue="slotProps.data[slotProps.column.field]?.id"/>
                    </div>
                    <div v-if="col.type === 'checkbox'">
                        <checkbox
                                @input="onCellEdit($event, slotProps)"

                                v-model="slotProps.data[slotProps.column.field]" :binary="true"></checkbox>

                    </div>
                </template>
            </Column>
            <!-- v-for -->

            <template #footer>
                סה״כ {{ data ? data.length : 0 }} רשומות.
            </template>
        </DataTable>
        <add-dialog
                :show="isDialogAdd"
                v-on:addItem="addItem"
                v-on:closeDialog="isDialogAdd = false"
        />

        <delete-dialog
                :title="'מחיקת משתמש'"
                :context="`האם תרצה להסיר  ${selectedRows.length}   הודעות מהמערכת?`"
                :show="isDialogDelete"
                v-on:choice="deleteItem"
        />
    </div>
</template>


<style scoped>
>>> textarea{
    width: -webkit-fill-available;
}
</style>